import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { useFTS0017ExperimentEffect } from './fts0017';
import { useFTS0018ExperimentEffect } from './fts0018';
export const useFTS0017orFTS0018ExperimentEffect = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);

  // FTS0017 is the in-app version of the experiment
  const {
    isFTS0017Loading,
    isFTS0017Variant
  } = useFTS0017ExperimentEffect();
  // FTS0018 is the public version of the experiment
  const {
    isFTS0018Loading,
    isFTS0018Variant
  } = useFTS0018ExperimentEffect();
  if (isAppAuth) {
    return {
      loading: isFTS0017Loading,
      variant: isFTS0017Variant
    };
  } else {
    return {
      loading: isFTS0018Loading,
      variant: isFTS0018Variant
    };
  }
};